<script setup lang="ts">
import { useFormContext } from "./useFormContext";

const { formId } = useFormContext();
</script>

<template>
  <form :id="formId" class="empty:hidden">
    <slot />
  </form>
</template>
